import { TutorStatus } from '../types';
export const isTutor = (type) => type === 'tutor';
export const isClient = (type) => ['student', 'parent'].includes(type);
export const isAdmin = (type) => type === 'admin';
export const isVolunteer = (status) => status === TutorStatus.VOLUNTEER;
export const isIdleTutor = ({ status, type }) => isTutor(type) && status === TutorStatus.IDLE;
//# sourceMappingURL=user.js.map